import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';
import FormRHF from "../../Components/Form/Form";
import FormControl from "../../Components/Form/FormControl";
import FormSelect from "../../Components/Form/FormSelect";
import FormCheck from "../../Components/Form/FormCheck";
import { apiGetProprietesFree, apiSoumissionFormulaireDemande } from '../../Datas/datasAutre.js'
import LoadingSpinner from "../../Components/LoadingSpinner";
import { appelRecupInfoGet, isValidSIRET } from '../../fonctionsDiv.js';


import '../../config.js';

const Etape2QuiformeFail = ({ formData, setFormData, onPrevious, onNext }) => {
    const navigate = useNavigate();

    const [dataLoaded, setDataLoaded] = useState(true);
    const [spinnerLoad, setSpinnerLoad] = useState(false);
    const [infosProprietes, SetInfosProprietes] = useState(undefined); // contient les infos sur les champ (taille max, caractre obligatoire, éditable...)
    const [messageProbleme, setMessageProbleme] = useState();
    const [aumoinsUneModif, setAumoinsUneModif] = useState(false); // pour avertir l'utilisateur en cas de sortie sans  enregistrement

    const [dataApi, setdataApi] = useState();

   //pour effectuer des actions en fonction de la saisie de l'utilisateur
    async function gestionEvenements(value, name){
      if(global.config.modeDebugApp == 1) console.log (`modif de ${name} : ${value[name]}`);
      setAumoinsUneModif(true);

      if(name == "x_SIRET" && value[name].length == 14) {
        var leSiret = value[name];        

        if(!isValidSIRET(leSiret)) {  //.length != 14
          alert("Le siret que vous avez saisi ne semble pas valide, veuillez le corriger.");  
          return false;
        }
        return false;
      }
    }

    
        const onSubmit = async (values) => {
          /*nok
          if(values["x_DATE_DECLARATION"] != null && dateModifCharFrToAmericSansSep(values["x_DATE_DECLARATION"]) > dateDuJourYYYYmmdd()) {
            alert("La date de déclaration ne peut être postérieure à la date du jour.");
            var ob = document.getElementById("x_DATE_DECLARATION");
            ob.focus();
            return false;
          }*/
          var leSiret = values["x_SIRET"];
    
          if(!isValidSIRET(leSiret)) {  //.length != 14
            alert("Le siret que vous avez saisi ne semble pas valide, veuillez le corriger.");
            var ob = document.getElementById("x_SIRET");
            ob.focus();
            return false;
          }

          setMessageProbleme();
          setDataLoaded(false);
          for(let i in values) if(values[i] === "") values[i] = null; // sinon génère une erreur : on met à null tout les champs vide (ract-hook-form semble le faire pour nous dans le cas ou on lui passe les valeurs par défaut en entré)
        
          if(values["x_RESPONSABLE_EMAIL"] != values["x_RESPONSABLE_EMAIL_CONFIRMATION"]) {
            alert("L\'e-mail de confirmation du responsable ne correspond pas à l'e-mail saisi, veuillez vérifier votre saisie.");
            var ob = document.getElementById("x_RESPONSABLE_EMAIL");
            ob.focus();
            return false;
          }
          if(global.config.modeDebugApp == 1) console.log("Values:::", values);
          if(global.config.modeDebugApp == 1) console.log("Values:::", JSON.stringify(values));
    
          var dataR = await apiSoumissionFormulaireDemande("", values, "envoi-formulaire/inscription");
          if(global.config.modeDebugApp == 1) console.log('retour apiSoumissionFormulaireDemande : ', dataR);
    
          switch (dataR.statusCode) {
              case 200: 
                   alert("Votre demande a bien été transmise, nous vérifions l'ensemble des éléments communiqués et revenons vers vous dans les plus brefs délais.");
                  navigate('/'); // Redirect to homepage
                  break;
              case 401:
                  setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
                  break;
              default:
                  setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
          }
          setDataLoaded(true);
        };
    
        
        const onError = (error) => {
          console.log("ERROR:::", error);
        };
    

    async function recupererProprietesFree() {
        const dataR = await apiGetProprietesFree();
        if(global.config.modeDebugApp == 1) console.log('retour apiGetProprietesFree : ', dataR);
        switch (dataR.statusCode) {
          case 200:
            // on duplique l'objet  x_RESPONSABLE_EMAIL pour pouvoir demander une confirmation
            var objPourConfirmation =  JSON.parse(JSON.stringify(dataR.dataApi["FomulaireInscription|x_RESPONSABLE_EMAIL"]));
            objPourConfirmation.lib_form = objPourConfirmation.lib_form + " (confirmation)"; // on clone (duplique) l'objet pour que  out fonctionne bien);
            objPourConfirmation.placeholder = objPourConfirmation.placeholder + " (confirmation)";
            dataR.dataApi["FomulaireInscription|x_RESPONSABLE_EMAIL_CONFIRMATION"] = objPourConfirmation
            
            SetInfosProprietes(dataR.dataApi);
             break;
          default:
            setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
        }
    }

    async function chargementsConsecutifs() {
      setDataLoaded(false);
      await recupererProprietesFree();
      var pb = false;
      //var ret = await appelRecupInfoGet("", "LEGALSTATUS", setMessageProbleme); 
      //if(ret != null) SetDataLEGALSTATUS(ret); else pb = true;
      if(pb == true ) setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
      setDataLoaded(true);
    }

    useEffect(() => {  
        setMessageProbleme(null);
        chargementsConsecutifs();
    }, []);

    const InputWithDiv = (props) => {
      return (<div className="alignement-horizontal-champs-form">
        <FormControl {...props} noCount="1" />
      </div>)
    };
    const FormCheckWithDiv = (props) => {
      return (<div className="alignement-horizontal-champs-form">
        <FormCheck {...props} />
      </div>)
    };



    // Pour test, on renseigne les champs obligatoires
    function renseigneToutPourTest() {
      const testData = {
        ...dataApi,
        x_SIRET: "80486581400029",
        x_SHORT_LIB: "test SHort",
        x_LIB_COMPANIES: "nom companie",
        x_UAI: "",
        x_NUM_DE: "12345678",
        x_DATE_DECLARATION: "01/01/2021",
        x_UAI: "12345678",
        x_ADDRESS1: "3 rue de la République",
        x_ADDRESS2: "Bâtiment A",
        x_CODE_POSTAL: "69540",
        x_LIB_VILLE: "Lyon",
        x_COMPANIES_PHONE_PORTABLE: "04 55 87 84 77",
        x_COMPANIES_PHONE_NUMBER_FIXE: "04 55 87 84 78",
        x_COMPANIES_EMAIL: "email-generique@gmail.com",
        x_URL: "https://url.com",

        x_RESPONSABLE_EMAIL: "email-resp@gmail.com",
        x_RESPONSABLE_EMAIL_CONFIRMATION: "email-resp@gmail.com",
        x_RESPONSABLE_FIRST_NAME: "Prénom responsable",
        x_RESPONSABLE_LAST_NAME: "Nom responsable",
        x_RESPONSABLE_TEL_PORTABLE: "04 55 87 84 87",
        x_RESPONSABLE_TEL_FIXE: "04 55 87 84 88",
      };
      setdataApi(testData);

      /*setFormData({      ...formData,
        RaisonSociale: "responsable nom",
      });*/
    }

  return (
    <div>
        {global.config.modeDebugAppDisplayInfosSupp == 1 && <div className='debug'>Etape2QuiformeFail</div>}
        <LoadingSpinner dataLoaded={dataLoaded}/>
        <LoadingSpinner dataLoaded={!spinnerLoad}  className="spinner-container3"/>
        <MessageErreurApi message={messageProbleme} />
        <h3>QuiForme n'a retourné aucune information concernant le siret {formData.Siret}.<br />
        vous pouvez renseigner le formulaire ci-dessous et le Carif vous contactera.</h3>

        {dataLoaded && infosProprietes && messageProbleme == null &&
        <>
          <ButtonDeBase typeSubmit={true} onClick={renseigneToutPourTest} lib="test : tout renseigner" className2="myside2" className=""/><br />
        
            <FormRHF onSubmit={onSubmit} onError={onError} dataApi={dataApi}  gestionEvenements={gestionEvenements} >
             <div className="titre-inscription">Identité</div>

              <InputWithDiv id="x_SIRET" infosProp={infosProprietes["FomulaireInscription|x_SIRET"]} nolib="1" value={formData.Siret} />
              <FormControl id="x_LIB_COMPANIES" infosProp={infosProprietes["FomulaireInscription|x_LIB_COMPANIES"]} nolib="1" />
              <InputWithDiv id="x_SHORT_LIB" infosProp={infosProprietes["FomulaireInscription|x_SHORT_LIB"]} nolib="1" />
              <InputWithDiv id="x_NUM_DE" infosProp={infosProprietes["FomulaireInscription|x_NUM_DE"]} nolib="1" />
              <InputWithDiv id="x_DATE_DECLARATION" infosProp={infosProprietes["FomulaireInscription|x_DATE_DECLARATION"]} nolib="1" classSpecifique="input-date-inline" />
              <br />
              <InputWithDiv id="x_UAI" infosProp={infosProprietes["FomulaireInscription|x_UAI"]} nolib="1" />

              {/*<FormSelect id="x_STATUT" infosProp={infosProprietes["FomulaireInscription|x_STATUT"]} options={dataLEGALSTATUS} nolib="1" />*/}

              
              <br />
              
              <div className="titre-inscription-separation">Coordonnées de l'organisme</div>

              <FormControl id="x_ADDRESS1" infosProp={infosProprietes["FomulaireInscription|x_ADDRESS1"]} nolib="1" />
              <FormControl id="x_ADDRESS2" infosProp={infosProprietes["FomulaireInscription|x_ADDRESS2"]} nolib="1" />
              <InputWithDiv id="x_CODE_POSTAL" infosProp={infosProprietes["FomulaireInscription|x_CODE_POSTAL"]} nolib="1" />
              <InputWithDiv id="x_LIB_VILLE" infosProp={infosProprietes["FomulaireInscription|x_LIB_VILLE"]} nolib="1" />
              <br />
              <InputWithDiv id="x_COMPANIES_PHONE_PORTABLE" infosProp={infosProprietes["FomulaireInscription|x_COMPANIES_PHONE_PORTABLE"]} nolib="1" />
              <InputWithDiv id="x_COMPANIES_PHONE_NUMBER_FIXE" infosProp={infosProprietes["FomulaireInscription|x_COMPANIES_PHONE_NUMBER_FIXE"]} nolib="1" />
              <br />
              <InputWithDiv id="x_COMPANIES_EMAIL" infosProp={infosProprietes["FomulaireInscription|x_COMPANIES_EMAIL"]} nolib="1" />
              <FormControl id="x_URL" infosProp={infosProprietes["FomulaireInscription|x_URL"]} nolib="1" />
              <br />


              <div className="titre-inscription-separation">Responsable de l'organisme</div>
              <MessageInfoBox nomClasse="message-info-important" 
                            message="L'Email ci-dessous sera utilisé pour envoyer les identifiants de connexion de votre organisme et les demandes de renouvellement de mot de passe." />< br />

              <InputWithDiv id="x_RESPONSABLE_EMAIL" infosProp={infosProprietes["FomulaireInscription|x_RESPONSABLE_EMAIL"]} nolib="1" />
              <InputWithDiv id="x_RESPONSABLE_EMAIL_CONFIRMATION" infosProp={infosProprietes["FomulaireInscription|x_RESPONSABLE_EMAIL_CONFIRMATION"]} nolib="1" /><br />

              <InputWithDiv id="x_RESPONSABLE_FIRST_NAME" infosProp={infosProprietes["FomulaireInscription|x_RESPONSABLE_FIRST_NAME"]} nolib="1" />
              <InputWithDiv id="x_RESPONSABLE_LAST_NAME" infosProp={infosProprietes["FomulaireInscription|x_RESPONSABLE_LAST_NAME"]} nolib="1" /><br />

              <InputWithDiv id="x_RESPONSABLE_TEL_PORTABLE" infosProp={infosProprietes["FomulaireInscription|x_RESPONSABLE_TEL_PORTABLE"]} nolib="1" />
              <InputWithDiv id="x_RESPONSABLE_TEL_FIXE" infosProp={infosProprietes["FomulaireInscription|x_RESPONSABLE_TEL_FIXE"]} nolib="1" />
              <br />

              <FormCheckWithDiv id="X_EST_CFA" infosProp={infosProprietes["FomulaireInscription|X_EST_CFA"]} typeCheckbox="checkbox" />

              <div><span className="text-obligatoire">Les champs signalés d'un astérisque rouge * sont obligatoires.</span></div>
              <div className="partie-bouton-droite">
                <ButtonDeBase typeSubmit={false} onClick={onPrevious} lib="Étape précédente" className2="myside2" className="" />
                &nbsp;&nbsp;&nbsp;                
                <ButtonDeBase typeSubmit={true} lib="Envoyer" disabled={aumoinsUneModif == true ? false : true} />
              </div>
              
          </FormRHF>
        </>
      }
    </div>
  );
};

export default Etape2QuiformeFail;
